var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#XMLID_22_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.411,
    y1: 0.00004368693,
    x2: 0.5927,
    y2: 0.00004368693,
    gradientTransform: "matrix(1761.5388 -1792.3081 1792.3081 1761.5388 -634.7711 1150.069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#070135"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#612D50"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M127,67.5H373c32.4,0,58.7,26.3,58.7,58.7v247.6c0,32.4-26.3,58.7-58.7,58.7H127 c-32.4,0-58.7-26.3-58.7-58.7V126.2C68.3,93.8,94.5,67.5,127,67.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st1",
    d: "M252.7,224.6c9.3,0,16.3-2,21.1-6.1c4.8-4,7.2-10,7.2-17.9c0-7.8-2.4-13.7-7.2-17.7 c-4.8-4.1-11.8-6.2-21.1-6.2h-32.6v47.9L252.7,224.6 M254.7,323.5c11.8,0,20.7-2.5,26.6-7.4c6-4.9,9-12.4,9-22.4 c0-9.8-3-17.1-8.9-22c-5.9-4.9-14.8-7.4-26.8-7.4h-34.6v59.2H254.7 M309.5,242.2c12.6,3.6,22.4,10.3,29.4,20.1 c6.9,9.8,10.4,21.8,10.4,36c0,21.8-7.4,38.1-22.3,48.8c-14.9,10.7-37.5,16.1-67.9,16.1h-97.8V137.1h88.4c31.7,0,54.7,4.7,68.9,14.2 c14.3,9.5,21.4,24.7,21.4,45.6c0,11-2.6,20.4-7.8,28.2C327,232.8,319.4,238.5,309.5,242.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostrap);
export default __webpack_public_path__ + "static/media/boostrap.53cd3aa8f35ff7df545aed9959d48212.svg";
export { ForwardRef as ReactComponent };